import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export const getTeamsApi = ({ teamId }) => {
  const url = `${endpoints.team.team}/${teamId}`;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const createTeamApi = ({ teamName, teamType }) => {
  const url = endpoints.team.team;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      name: teamName,
      teamType,
    },
  });
};

export const pendingInvitesApi = (employeeId) => {
  const url = endpoints.team.pendingInvites(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const inviteUserApi = ({ email, teamUuid, widgetType }) => {
  const url = endpoints.team.inviteUser;
  return sendRequest({
    url,
    method: 'POST',
    queryParams: {
      widgetType,
    },
    body: {
      email,
      teamUuid: parseInt(teamUuid),
    },
    credentials: 'include',
  });
};

export const updateInviteApi = ({ email, teamUuid, status }) => {
  const url = endpoints.team.updateInvite;
  return sendRequest({
    url,
    method: 'POST',
    body: {
      email,
      teamUuid: parseInt(teamUuid),
      status,
    },
    credentials: 'include',
  });
};

export const updateEmployeeRoleApi = ({ newRole, employeeId, teamId }) => {
  const url = endpoints.team.updateEmployeeRole(teamId, employeeId);
  return sendRequest({
    url,
    method: 'POST',
    body: {
      userRole: newRole,
    },
    credentials: 'include',
  });
};

export const changeDefaultTeamApi = ({ employeeId, teamId }) => {
  const url = endpoints.team.changeDefaultTeam(employeeId, teamId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
  });
};

export const removeEmployeeApi = ({ employeeId, teamId }) => {
  const url = endpoints.team.removeEmployee(employeeId, teamId);
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
};

export const updateTeamApi = ({ teamId, teamName, visibilityType, teamType }) => {
  const url = endpoints.team.update(teamId);
  return sendRequest({
    url,
    method: 'PUT',
    body: {
      name: teamName,
      visibilityType,
      teamType,
    },
    credentials: 'include',
  });
};

export const deleteTeamApi = (teamId) => {
  const url = endpoints.team.delete(teamId);
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
};

export const getCohortTeamEmployeesApi = ({ selectedCohort = null }) => {
  const url = endpoints.managers.team.cohortTeamEmployees;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      moduleType: 'goal',
    },
    body: selectedCohort,
    method: 'POST',
  });
};
